const Quote = () => (
    <svg
        width="16"
        height="12"
        viewBox="0 0 16 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M16 0C15.7134 1.24082 15.4109 2.57959 15.0925 4.01633C14.7741 5.45306 14.4876 6.85714 14.2328 8.22857C13.9781 9.6 13.7711 10.8571 13.6119 12H9.07463L8.7403 11.4612C9.02687 10.3184 9.39303 9.09388 9.83881 7.78776C10.2846 6.44898 10.7781 5.1102 11.3194 3.77143C11.8607 2.43265 12.3861 1.17551 12.8955 0H16ZM7.16418 0C6.87761 1.24082 6.57512 2.57959 6.25672 4.01633C5.93831 5.45306 5.65174 6.85714 5.39701 8.22857C5.14229 9.6 4.93532 10.8571 4.77612 12H0.286567L0 11.4612C0.286567 10.3184 0.652736 9.09388 1.09851 7.78776C1.54428 6.44898 2.02189 5.1102 2.53134 3.77143C3.07264 2.43265 3.59801 1.17551 4.10746 0H7.16418Z"
            fill="#1A5B77"
        />
    </svg>
);

export default Quote;
